import { BaseProductSerializer } from './BaseProductSerializer';
import { GlossaryTextSerializer } from './GlossaryTextSerializer';

class ProductSerializer {
  static deSerialize(data) {
    const baseProduct = BaseProductSerializer.deSerialize(data);
    const characteristicsData = data.CaracteristicasWeb || [];
    return {
      ...baseProduct,
      characteristics: ProductSerializer.deSerializeCharacteristics(characteristicsData),
      model: (data.ArtDescripcion || '').trim(),
      stockLevelLastUpdate: data.FechaStock || null,
      serviceAvailabilityText: data.ArticuloVienenTextoWeb || null,
      // NOTE: The service text is the first characteristic
      serviceMessage: (data.CaracteristicasArticulosTextoWeb || [{}])[0].CATTexto || null,
      serviceProduct: data.Instalacion ? ProductSerializer.deSerialize(data.Instalacion) : null,
    };
  }

  static deSerializeCharacteristics(characteristics) {
    return characteristics.map((category) => {
      const characteristicsData = category.CaracteristicasArticulos || [];
      return {
        id: String(category.CAGID),
        name: category.CAGNombre,
        index: category.CAGOrden,
        characteristics: characteristicsData.map((char) => {
          const key = char.CArNombre;
          const id = String(char.CArID);
          let value = null;
          let featured = null;
          const visible = char.CarVisible;
          if (char.CaracteristicasArticulosValor && char.CaracteristicasArticulosValor[0]) {
            let charValue = char.CaracteristicasArticulosValor[0].CAVValor || '';
            // NOTE: values equal to '1' symbolize a true characteristic. We replace it
            // with a check mark so that it looks good.
            if (charValue === 'Si') {
              charValue = '✓';
            }
            const charDescription = char.CaracteristicasArticulosValor[0].CAVDescripcion || '';
            value = `${charValue} ${charDescription}`.trim().split('\r\n').filter(Boolean);
            value = value.map(GlossaryTextSerializer.deSerialize);
            featured = char.CaracteristicasArticulosValor[0].CAVDestacado || '';
          }
          return {
            id,
            key,
            value,
            featured,
            visible,
          };
        }),
      };
    }).sort((c1, c2) => (c1.index - c2.index < 0 ? -1 : 1));
  }
}

export { ProductSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/ProductSerializer.js